import React, { useState } from "react";
import { Search, ChevronDown, Filter } from "lucide-react";
import { Link } from "react-router-dom";
import TableComponent from "../../../shared/components/table";
import {
  PresidentCaseFolderColumns,
  PresidentRecusedCaseFolderColumns,
} from "../../../shared/components/table/columns/presidentCaseFolderColumns";
import { PresidentPanelsColumns } from "../../../shared/components/table/columns/presidentPanelsColumns";
import { SortingState } from "@tanstack/react-table";
import { Menu, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { ARROW_LEFT } from "../../../assets";
import RecusalRequestModal, {
  ReasonForRefusalModal,
  RecusalDeclinedSuccessModal,
} from "./case-folder/modals/RecusalRequestModal";
import SuccessModalV2 from "../../../shared/components/successModal/sucessModalV2";

const topTabs = ["All cases", "Panels"];
const subTabs = ["Ready for assignment", "Reassigned", "Recalled", "Recused"];

const panelInnerTabs = ["All Judges", "By Panels"];

const dropdownFilters = [
  "Assigned cases",
  "Cases ready for assignment",
  "Recused",
  "Recalled",
];

const CaseFolders = () => {
  const [activeTopTab, setActiveTopTab] = useState("All cases");
  const [activeSubTab, setActiveSubTab] = useState("Ready for assignment");
  const [activePanelInnerTab, setActivePanelInnerTab] = useState("All Judges");
  const [sorting, setSorting] = useState<SortingState>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [activeDropdownFilter, setActiveDropdownFilter] = useState("All cases");
  const [showRecusalModal, setShowRecusalModal] = useState(false);
  const [showRecusalSuccess, setShowRecusalSuccess] = useState(false);
  const [showRefusalModal, setShowRefusalModal] = useState(false);
  const [showRefusalSuccess, setShowRefusalSuccess] = useState(false);

  const handleViewRecusalRequest = () => {
    setShowRecusalModal(true);
  };

  const handleApproveRecusal = () => {
    setShowRecusalModal(false);
    setShowRecusalSuccess(true);
  };

  const handleDeclineRecusal = () => {
    setShowRecusalModal(false);
    setShowRefusalModal(true);
  };

  const handleSubmitRefusal = () => {
    setShowRefusalModal(false);
    setShowRefusalSuccess(true);
  };

  const mockData = [
    {
      sn: false,
      date: "31-05-2024",
      title: "Olugbenga Akintola vs Israel Anyemalu",
      appeal_number: "CV/3047/2018",
      details: "View",
      assigned_panel: "Panel A",
    },
    {
      sn: false,
      date: "31-05-2024",
      title: "Olugbenga Akintola vs Israel Anyemalu",
      appeal_number: "CV/3047/2018",
      details: "View",
      assigned_panel: "Panel C",
    },
    {
      sn: false,
      date: "31-05-2024",
      title: "Olugbenga Akintola vs Israel Anyemalu",
      appeal_number: "CV/3047/2018",
      details: "View",
      assigned_panel: "Panel B",
    },
    {
      sn: false,
      date: "31-05-2024",
      title: "Olugbenga Akintola vs Israel Anyemalu",
      appeal_number: "CV/3047/2018",
      details: "View",
      assigned_panel: "Panel B",
    },
    {
      sn: false,
      date: "31-05-2024",
      title: "Olugbenga Akintola vs Israel Anyemalu",
      appeal_number: "CV/3047/2018",
      details: "View",
      assigned_panel: "N/A",
    },
  ];

  const recusedData = [
    {
      sn: 1,
      date: "31-05-2024",
      title: "Olugbenga Akintola vs Israel Anyemalu",
      appeal_number: "CV/3047/2018",
      details: "View",
      status: "Recusal requested",
      assigned_judge: "Hon. Justice Esther Ochendo",
      onViewRequest: handleViewRecusalRequest,
    },
    {
      sn: 2,
      date: "31-05-2024",
      title: "Olugbenga Akintola vs Israel Anyemalu",
      appeal_number: "CV/3047/2018",
      details: "View",
      status: "Recusal requested",
      assigned_judge: "Hon. Justice Esther Ochendo",
      onViewRequest: handleViewRecusalRequest,
    },
    {
      sn: 3,
      date: "31-05-2024",
      title: "Olugbenga Akintola vs Israel Anyemalu",
      appeal_number: "CV/3047/2018",
      details: "View",
      status: "Recusal requested",
      assigned_judge: "Hon. Justice Esther Ochendo",
      onViewRequest: handleViewRecusalRequest,
    },
  ];

  const panelData = [
    {
      sn: 1,
      panel_name: "Panel A",
      judges: [
        "Hon. Justice Esther Ochendo",
        "Hon. Justice Mba",
        "Hon. Justice Eze",
      ],
      admin: "Admin",
      court_number: "Court 2",
      subject_matter: "Criminal",
      status: "Active",
      docket: "",
    },
    {
      sn: 2,
      panel_name: "Panel B",
      judges: [
        "Hon. Justice Esther Ochendo",
        "Hon. Justice Mba",
        "Hon. Justice Eze",
      ],
      admin: "Admin",
      court_number: "Court 3",
      subject_matter: "Civil",
      status: "Active",
      docket: "",
    },
    {
      sn: 3,
      panel_name: "Panel C",
      judges: [
        "Hon. Justice Esther Ochendo",
        "Hon. Justice Mba",
        "Hon. Justice Eze",
      ],
      admin: "Admin",
      court_number: "Court 4",
      subject_matter: "Civil",
      status: "Active",
      docket: "",
    },
  ];

  return (
    <div className="flex flex-col h-full min-h-screen ">
      {/* Header */}
      <div className="bg-white px-8 pt-6 pb-0 border-b border-[#E9EAEB]">
        {activeTopTab === "Panels" ? (
          <div className="flex items-center justify-between">
            <h1 className="text-2xl font-bold text-[#1A1A1A]">Panels</h1>
            <button className="flex items-center gap-2 px-4 py-2.5 rounded-lg border border-[#D0D5DD] bg-white text-sm font-medium text-[#111827] shadow-sm">
              <Filter className="w-4 h-4 text-[#111827]" />
              <span>All Judges</span>
            </button>
          </div>
        ) : (
          <div>
            <h1 className="text-2xl font-bold text-[#1A1A1A]">Case Folder</h1>
            <div className="flex items-center gap-x-2 text-sm text-[#464255] mt-2 mb-2">
              <Link to="/president/overview" className="hover:text-[#00B074]">
                Home
              </Link>
              <img src={ARROW_LEFT} alt="arrow" className="w-3 h-3" />
              <span className="font-medium text-[#1A1A1A]">Case Folder</span>
            </div>
          </div>
        )}
      </div>

      {/* Tabs / breadcrumbs */}
      {activeTopTab === "All cases" && (
        <div className="bg-white border-b border-[#E9EAEB] px-8 pt-4">
          <div className="flex items-center border-b w-full gap-8 text-sm font-medium">
            {topTabs.map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTopTab(tab)}
                className={`pb-3 border-b-2 ${
                  activeTopTab === tab
                    ? "border-[#111827] text-[#111827]"
                    : "border-transparent text-[#667085]"
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
          <div className="flex items-center gap-6 mt-4 text-sm font-medium">
            {subTabs.map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveSubTab(tab)}
                className={`pb-3 border-b-2 ${
                  activeSubTab === tab
                    ? "border-[#111827] text-[#111827]"
                    : "border-transparent text-[#667085]"
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Search, filter, and table */}
      {activeTopTab === "All cases" && (
        <>
          <div className="px-8 py-6 flex flex-col gap-4">
            <div className="flex items-center justify-between">
              <div className="relative w-full max-w-[320px]">
                <input
                  type="text"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-4 pr-10 py-2.5 rounded-lg border border-[#D0D5DD] focus:outline-none focus:border-[#00B074] bg-white text-sm"
                />
                <Search className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#9A9A9A]" />
              </div>

              <Menu as="div" className="relative inline-block text-left ml-4">
                <Menu.Button className="flex items-center gap-2 px-4 py-2.5 rounded-lg border border-[#D0D5DD] bg-white text-sm font-medium text-[#344054] shadow-sm">
                  <Filter className="w-4 h-4 text-[#667085]" />
                  <span>{activeDropdownFilter}</span>
                  <ChevronDown className="w-4 h-4 text-[#667085]" />
                </Menu.Button>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="absolute right-0 mt-2 w-60 origin-top-right rounded-2xl bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50 py-2">
                    <div className="px-1 py-1 flex flex-col gap-y-1">
                      {dropdownFilters.map((option) => (
                        <Menu.Item key={option}>
                          {({ active }) => (
                            <button
                              onClick={() => setActiveDropdownFilter(option)}
                              className={`${
                                option === "Cases ready for assignment" &&
                                activeDropdownFilter === option
                                  ? "bg-[#E6F7F1] text-[#027A48]"
                                  : active
                                    ? "bg-gray-50 text-[#344054]"
                                    : "text-[#344054]"
                              } group flex w-full items-center rounded-lg px-4 py-2.5 text-sm`}
                            >
                              {option}
                            </button>
                          )}
                        </Menu.Item>
                      ))}
                    </div>
                  </Menu.Items>
                </Transition>
              </Menu>
            </div>
          </div>

          <div className="flex-1 px-8 pb-10">
            <div className="bg-white rounded-2xl">
              <TableComponent
                DATA={activeSubTab === "Recused" ? recusedData : mockData}
                // @ts-ignore
                COLUMNS={
                  activeSubTab === "Recused"
                    ? PresidentRecusedCaseFolderColumns
                    : PresidentCaseFolderColumns
                }
                sorting={sorting}
                setSorting={setSorting}
              />

              <div className="flex items-center justify-between px-6 py-4 border-t border-[#E4E7EC] text-sm text-[#667085]">
                <div className="flex items-center gap-2">
                  <span>
                    Page <span className="font-medium">1</span> of{" "}
                    <span className="font-medium">10</span>
                  </span>
                </div>
                <div className="flex items-center gap-4">
                  <div className="flex items-center gap-2">
                    <button className="px-3 py-1.5 rounded-lg border border-[#D0D5DD] bg-white hover:bg-gray-50">
                      Previous
                    </button>
                    <button className="px-3 py-1.5 rounded-lg border border-[#D0D5DD] bg-white hover:bg-gray-50">
                      Next
                    </button>
                  </div>
                  <div className="flex items-center gap-2">
                    <span>Entries per page:</span>
                    <select className="border border-[#D0D5DD] rounded-lg px-2 py-1 bg-white focus:outline-none text-sm">
                      <option>10</option>
                      <option>20</option>
                      <option>50</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {activeTopTab === "Panels" && (
        <>
          <div className="bg-white border-b border-[#E9EAEB] px-8 pt-4">
            <div className="flex items-center border-b border-[#E9EAEB] w-full gap-x-2 text-sm text-[#464255] mb-4 pb-5">
              <Link to="/president/overview" className="hover:text-[#00B074]">
                Home
              </Link>
              <img src={ARROW_LEFT} alt="arrow" className="w-3 h-3" />
              <span className="hover:text-[#1A1A1A]">Case folder</span>
              <img src={ARROW_LEFT} alt="arrow" className="w-3 h-3" />
              <span className="font-medium text-[#1A1A1A]">Panels</span>
            </div>
            <div className="flex items-center gap-8 text-sm font-medium">
              {panelInnerTabs.map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActivePanelInnerTab(tab)}
                  className={`pb-3 border-b-2 ${
                    activePanelInnerTab === tab
                      ? "border-[#111827] text-[#111827]"
                      : "border-transparent text-[#667085]"
                  }`}
                >
                  {tab}
                </button>
              ))}
            </div>
          </div>

          <div className="px-8 py-6 flex flex-col gap-4">
            <div className="flex items-center">
              <div className="relative w-full max-w-[320px]">
                <input
                  type="text"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-4 pr-10 py-2.5 rounded-lg border border-[#E5E7EB] focus:outline-none focus:border-[#111827] bg-white text-sm"
                />
                <Search className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#9CA3AF]" />
              </div>
            </div>
          </div>

          <div className="flex-1 px-8 pb-10">
            <div className="bg-white rounded-2xl border border-[#E5E7EB]">
              <TableComponent
                DATA={panelData}
                // @ts-ignore
                COLUMNS={PresidentPanelsColumns}
                sorting={sorting}
                setSorting={setSorting}
              />
            </div>
          </div>
        </>
      )}
      <RecusalRequestModal
        isOpen={showRecusalModal}
        onClose={() => setShowRecusalModal(false)}
        onApprove={handleApproveRecusal}
        onDecline={handleDeclineRecusal}
      />
      <SuccessModalV2
        open={showRecusalSuccess}
        close={() => setShowRecusalSuccess(false)}
        message="Recusal request approved!"
      />
      <ReasonForRefusalModal
        isOpen={showRefusalModal}
        onClose={() => setShowRefusalModal(false)}
        onSubmit={handleSubmitRefusal}
      />
      <RecusalDeclinedSuccessModal
        isOpen={showRefusalSuccess}
        onClose={() => setShowRefusalSuccess(false)}
      />
    </div>
  );
};

export default CaseFolders;
